// extracted by mini-css-extract-plugin
export default {"roomInfo":"index_roomInfo__msMrw","roomInfoContent":"index_roomInfoContent__jckNX","sperature":"index_sperature__nyPuk"};